/*
 * @description: 招标公告路由配置
 * @author: Vincent
 * @since: 2022-06-21 11:03:46
 * @version: 1.0
 */
import PublicLayout from '@/framework/layout2/PublicLayout.vue'
export default [
  {
    path: '/notice',
    component: PublicLayout,
    children: [
      {
        path: 'bid-notice',
        component: () => import('@/app/notice/views/index'),
        name: 'BidNotice',
        meta: { title: 'module.isp-notice.098673-0', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'bid-winning-notice',
        component: () => import('@/app/notice/views/bid-winning-notice'),
        name: 'BidWinningNotice',
        meta: { title: 'module.isp-notice.098673-1', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'supplier-requirement',
        component: () => import('@/app/notice/views/supplier-requirement'),
        name: 'SupplierRequirement',
        meta: { title: 'module.isp-notice.098673-2', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'information',
        component: () => import('@/app/notice/views/information'),
        name: 'RequirementInformation',
        meta: { title: 'module.isp-notice.098673-3', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'announcement-details',
        component: () => import('@/app/notice/views/announcementdetails'),
        name: 'announcementdetails',
        meta: { title: 'module.isp-notice.098673-4', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'system-notice',
        component: () => import('@/app/notice/views/systemNotice'),
        name: 'systemNotice',
        meta: { title: 'module.isp-notice.098673-5', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'pay-notice',
        component: () => import('@/app/notice/views/payNotice'),
        name: 'payNotice',
        meta: { title: 'module.isp-notice.098673-6', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
      {
        path: 'notice-details',
        component: () => import('@/app/notice/views/details'),
        name: 'noticeDetails',
        meta: { title: 'module.isp-notice.098673-4', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      },
    ]
  }
]

